import { render } from "./Regionalprefs.vue?vue&type=template&id=53b2a41c"
import script from "./Regionalprefs.vue?vue&type=script&lang=js"
export * from "./Regionalprefs.vue?vue&type=script&lang=js"

import "./Regionalprefs.vue?vue&type=style&index=0&id=53b2a41c&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__